export function setPrintQueue(state, val) {
  state.printQueue = Array.isArray(val) ? val : [];
}
